<template>

  <mdc-dialog v-model="isOpen"
              :title="'report.skill_domain' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              :accept-disabled="disabled"
              @accept="close"
              @cancel="close"
              @validate="save">
    <div class="close-cross" @click="close()">
      <mdc-icon icon="close"></mdc-icon>
    </div>
    <loader v-if="!isLoaded" class="table-loader"></loader>


      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="name"
                         type="text"
                         :label="'report.skill_domain' | trans"
                         name="name"
                         :class="{'is-invalid': errors.has('name')}"
                         v-validate="{required: true}"
                         v-model="name"
                         autocomplete="new-clinicName"
                         data-vv-validate-on="none"
                         :data-vv-as="'report.skill_domain' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('name') && errors.firstRule('name') != 'regex'">
              <strong>{{ errors.first('name') }}</strong>
          </span>

          <span class="invalid-feedback"
                v-if="errors.firstRule('name') === 'regex' ">
              <strong>{{'validation.regex', {attribute: name} | trans}}</strong>
          </span>
        </div>
      </div>

  </mdc-dialog>

</template>

<script>
  import {mapActions} from 'vuex';
  import {Validator} from 'vee-validate';
  import lang from '../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';
  import cloneDeep from 'lodash/cloneDeep';
  import Loader from '../../loader/components/Loader';
  import axios from 'axios';
  import Uploader from '../../fileUpload/components/Uploader';
  import Manager from '../api/Manager';

  export default {
    name: 'ClinicalModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        name: null,
        isLoaded: true,
        disabled: false

      };
    },
    async created() {
      this.name = this.data.name;
    },
    components: {
      Loader, Uploader
    },
    methods: {
      async save() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }

        try {
          let isSaved;

          if(this.data.id){
            isSaved = await Manager.setSkillDomain(this.name, this.data.id);
          } else{
            isSaved = await Manager.addSkillDomain(this.name);
          }
          if (isSaved){
            this.close();
          }

        } catch (response) {
            let errors = response.data.errors;
            if (isObject(errors)) {
              if (errors.message) {
                this.errors.add('server', errors.message);
              } else {
                for (let key of Object.keys(errors)) {
                  let {message} = errors[key].message ? errors[key] : errors[key][0];
                  this.errors.add(key, message);
                }
              }
            }
        } finally {
          this.disabled = false;
          this.isloading = true;
        }
      },
      reset() {
        Object.assign(this.$data, this.$options.data());
        this.errors.clear();
      },
      close() {
        this.reset();
        this.$emit('close');
      },

    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/SkillModal.vue